import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { withRouter } from 'react-router';
import v from 'validate.js';
import styles from './style.module.css';
import * as Routes from '../../../../../constants/routes';
import { onSubmit } from '../../../../../common/components/submit-button';
import RenderSelect from '../../../../../common/components/render-input/select';
import RenderInput from "../../../../../common/components/render-input";

export const formName = Routes.STEPTHREE;

const validate = values => v(values, {
    interestTerm: {
        presence: {
            allowEmpty: false,
            message: 'is required'
        }
    }
});

const interestTermOptions = [
    'MeritLine (Home Equity line of credit)',
    'Personal Loans',
    'Overdraft Protection',
    'Collabria VISA® Credit Cards'
];

const defaultInterestTermIndex = 1; // Personal Loans

class StepThreeForm extends Component {
    render() {
        return (
            <form className={styles.form}>
                <Field
                    name='interestTerm'
                    options={interestTermOptions}
                    component={RenderSelect}
                />
                <h2 className={styles.mainTitle}>Your Interest Rate</h2>
                <p className={styles.text}>
                    Based on the information you provided us, here’s your estimated interest rate
                </p>
                <Field
                    name='interestRate'
                    prefix='%'
                    readOnlyValue='4.95'
                    component={RenderInput}
                />
            </form>
        );
    }
}

StepThreeForm = reduxForm({
    form: formName,
    destroyOnUnmount: false,
    validate,
    onSubmit,
    initialValues: {
        interestTerm: defaultInterestTermIndex
    },
    redirectPath: `/loan${Routes.STEPFOUR}`
})(StepThreeForm);

export default withRouter(StepThreeForm);

